<template>
  <b-container>
    <b-table :items="items"></b-table>
  </b-container>
</template>

<script>
const items = [
  {
    Inspiration: '2.900 €, proyectos de 2 meses',
    Discovery: '6.900 €, proyectos de 3 meses',
    'Discovery+': '14.900 €, proyectos de 6 meses',
    Ascension: '27.900 €, proyectos de 9 meses'
  },
  {
    Inspiration: 'Breadboard prototype',
    Discovery: 'Engineering Prototype',
    'Discovery+': 'Functional Prototype (MVP)',
    Ascension: 'Preproduction prototype'
  },
  {
    Inspiration: '$1,450 upfront $1,450 upon project completion',
    Discovery: '$1,900 upfront 2 x $2,500/month',
    'Discovery+': '$2,400 upfront 5 x $2,500/month',
    Ascension: '$3,900 upfront 8 x $3,000/month'
  },
  {
    Inspiration: 'Residual Cost: $0',
    Discovery: 'Residual Cost: $9,900 *',
    'Discovery+': 'Residual Cost: $24,900 *',
    Ascension: 'Residual Cost: $49,900 * or equity **'
  },
  {
    Inspiration: 'Materials cost covered up to $400',
    Discovery: 'Materials cost covered up to $800',
    'Discovery+': 'Materials cost covered up to $800',
    Ascension: 'Materials cost covered up to $1,600'
  },
  {
    Inspiration: 'Development Kits Assembly',
    Discovery: 'Engineering Prototype',
    'Discovery+': 'Custom Formfactor PCB Assembly',
    Ascension: 'Custom Formfactor PCB Assembly & Custom Mechanical Parts'
  },
  {
    Inspiration: 'Test Firmware (Open Source Libraries)',
    Discovery: 'Custom Formfactor PCB Assembly',
    'Discovery+': 'Custom Firmware',
    Ascension: 'Full Custom Firmware & Software Integration'
  },
  {
    Inspiration: 'Housing Design',
    Discovery: 'Aesthetic & Housing Design',
    'Discovery+': 'Custom Firmware',
    Ascension: 'Full Custom Firmware & Software Integration'
  },
  {
    Inspiration: 'Test Firmware (Open Source Libraries)',
    Discovery: 'Custom Formfactor PCB Assembly',
    'Discovery+': 'Housing Design',
    Ascension: 'Aesthetic & Housing Design'
  }
]

export default {
  name: 'prices',
  data () {
    return {
      items
    }
  }
}
</script>

<style>

</style>
